import CartAlertMessage from './CartAlertMessage'

export default CartAlertMessage
